export const specialMenu = [
    {
        id: 1,
        title: 'Buttermilk Pancakes',
        category: 'breakfast',
        price: '225',
        image: 'https://img.kidspot.com.au/Ywp5DOMa/kk/2015/03/buttermilk_pancakes_final-607368-1.jpg'
    },
    {
        id: 2,
        title: 'Chicken Biryani',
        category: 'lunch',
        price: '255',
        image: 'https://www.awesomecuisine.com/wp-content/uploads/2007/10/Chicken-Biryani_resized-500x436.jpg'
    },
    {
        id: 3,
        title: 'Cheese Balls',
        category: 'lunch',
        price: '125',
        image: 'https://i.ytimg.com/vi/utqYhiRFBN8/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLBlwWcw8HC8OvKlsFrByGv5A3AYDw'
    },
    {
        id: 4,
        title: 'Corn Pudding',
        category: 'breakfast',
        price: '155',
        image: 'https://www.allrecipes.com/thmb/iGh9kHORBPDpNTLizBxIBRQZCyg=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/AR-15985-GrandmasCornPudding-DDMFS-4x3-dc8c85c9cefb4ba3b1d0fc3ff41516f3.jpg'
    },
    {
        id: 5,
        title: 'Corn Pizza',
        category: 'lunch',
        price: '155',
        image: 'https://i0.wp.com/www.foodorderkar.com/wp-content/uploads/2022/10/478335.jpg?fit=640%2C480&ssl=1'
    },
    {
        id: 6,
        title: 'Salmon Cake',
        category: 'snacks',
        price: '255',
        image: 'https://www.onceuponachef.com/images/2017/12/Salmon-Cakes-1-16.jpg'
    },
    {
        id: 7,
        title: 'Sandwich',
        category: 'snacks',
        price: '125',
        image: 'https://www.maggi.ph/sites/default/files/styles/home_stage_944_531/public/srh_recipes/91afe3a3615aaa162847dc3fdcdda2da.jpg?h=476030cb&itok=fMS4ereQ'
    },
    {
        id: 8,
        title: 'Chicken pie',
        category: 'snacks',
        price: '120',
        image: 'https://i.ytimg.com/vi/gya4lQDYzeA/maxresdefault.jpg'
    }
]